var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"svginject",rawName:"v-svginject"}],staticClass:"icon preloader noarrow",class:( _obj = {}, _obj[_vm.iconClass] = !!_vm.iconClass, _obj['rmalttext-disable'] =  _vm.selected, _obj ),attrs:{"data-alt":_vm.alt,"data-alt-pos":"left","data-alt-offset":"9"}},[(_vm.svgIcon)?_c('img',{staticClass:"svg svg-icon",attrs:{"src":_vm.svgIcon}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }